module.exports = __webpack_public_path__ + "static/media/icon_youxiaofanghu.e295e9f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/icon_youxiaofanghu.svg
// module id = 528
// module chunks = 0